import { getDocumentLang } from '../../helpers';

export const linkIosManifest = () => {
  const link = document.createElement('link');
  const manifestPath = getDocumentLang() === 'ru_RU' ? './manifest.ru.json' : './manifest.en.json';
  link.rel = 'manifest';

  link.href = manifestPath;
  document.head.appendChild(link);
};
